import React, { useState } from "react";
import AlertDialog from "../components/alert.component";
import Grid from "@material-ui/core/Grid";
import { Button } from "@material-ui/core";
import { isEmpty } from "lodash";

import TestimonialForm from "./testimonial.form";

import { Api } from "../utils/api";

const api = new Api();

const TestimonialNew = (props) => {
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertTitle, setAlertTitle] = useState("");

  const testimonialType = props.location.pathname.includes("professional")
    ? "professional"
    : "particular";

  const onSubmit = async (data) => {
    const formData = new FormData();

    formData.append(`testimonial[type]`, testimonialType);

    Object.keys(data).map((attr) => {
      if (attr == "file") {
        if (!isEmpty(data["file"])) {
          formData.append(`testimonial[${attr}]`, data[attr][0]);
        }
      } else {
        formData.append(`testimonial[${attr}]`, data[attr]);
      }
    });

    const res = await fetch(`${api.apiBase}/testimonials`, {
      method: "POST",
      body: formData,
    });

    if (res.status === 201) {
      const data = await res.json();
      props.history.push(`/testimonials/${testimonialType}/${data.id}/edit`);
    } else {
      setAlertMessage("Erro na criação do testemunho");
      setAlertTitle("Erro");
      setShowAlert(true);
    }
  };

  return (
    <>
      <AlertDialog
        open={showAlert}
        handleClose={() => setShowAlert(false)}
        title={alertTitle}
        message={alertMessage}
      ></AlertDialog>
      <TestimonialForm
        onSubmit={onSubmit}
        testimonialsType={testimonialType}
      ></TestimonialForm>
      <Grid container spacing={4}>
        <Grid item xs={1}></Grid>
        <Grid item xs={6}>
          <Button href={`/testimonials/${testimonialType}`} variant="contained">
            Voltar
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default TestimonialNew;
